module.exports = "### State Management\n\n- Components can manage state\n\n- Large apps generally want state in one central place\n\n- Redux / MobX \n  - Popular solutions\n  - Different approaches\n\n### Redux\n- Based on Flux ideas\n- State lives in a single store\n- Emit actions (object describing changes)\n- Transform state using reducers (pure functions)\n\n### Mobx\n- Functional Reactive Programming\n- Observables\n- Computed values\n- Reactions"


//////////////////
// WEBPACK FOOTER
// ./src/slides/12_beyond_basics/notes_3.md
// module id = 1536
// module chunks = 0